import { css, setFlexDFAICJCSB, setProps, setRowReverse, styled } from "theme";

type SRowProps = {
  isMedium: boolean;
  isBig: boolean;
  isArabic: boolean;
};

const isMediumSet = setProps<SRowProps>(({ isMedium }) => isMedium)(css`
  width: 440px;
`);

const isBigSet = setProps<SRowProps>(({ isBig }) => isBig)(css`
  width: 500px;
`);

export const SRow = styled.div<SRowProps>`
  margin-bottom: 10px;

  ${setFlexDFAICJCSB};
  ${isMediumSet};
  ${isBigSet};
  ${setRowReverse()};
`;
